import React from "react";
import { AddBoxOutlined } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { ColumnDialogParams, ColumnModelItem } from "components/tables/columns/ColumnModel";
import { ColumnDialogMode } from "components/tables/columns/ColumnModel"; 

interface RecordTableToolbarProps {
  hiddenColumns: ColumnModelItem[];
  onColumnDialogAction: (params: ColumnDialogParams) => void;
}

export default function RecordTableToolbar(props: RecordTableToolbarProps) {
  const { i18n } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "36px"
      }}>
      {!props.hiddenColumns.length
        ?
        <Typography variant="h5">{i18n.t("tables.all-columns-added")}</Typography>
        :
        <Button
          color="success"
          variant="contained"
          startIcon={<AddBoxOutlined />}
          onClick={() => {
            props.onColumnDialogAction && props.onColumnDialogAction({ mode: ColumnDialogMode.ADD_COLUMN });
          }}
        >
          {i18n.t("tables.add-column")}
        </Button>
      }
    </Box>
  );
};